import React from "react";
import {Box, Text} from "@unibuddy/patron";
import {IconLockClosed} from "@unibuddy/icons";
import {useTranslation} from "@unibuddy/intl";
import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_SECURE_AND_ANONYMISED_MESSAGE} from "../../../../../translations/chat";

export function SecureMessage() {
    const {t} = useTranslation(IntlNamespaces.CHAT);
    return (
        // Parent must be a <ul> element
        <Box
            display="flex"
            justifyContent="center"
            marginY="small"
            paddingX="small"
            role="listitem"
        >
            <Box
                display="flex"
                paddingY="small"
                paddingX="medium"
                borderRadius="full"
                bgColor="#FFFACC"
                gap="xxsmall"
                alignItems="center"
                shadow="small"
            >
                <Box minW="16px" minH="16px" display="flex" alignItems="flex-start">
                    <IconLockClosed aria-hidden width={16} height={16} />
                </Box>
                <Text size="small" align="center">
                    {t(
                        INTL_SECURE_AND_ANONYMISED_MESSAGE.key,
                        INTL_SECURE_AND_ANONYMISED_MESSAGE.defaultValue,
                    )}
                </Text>
            </Box>
        </Box>
    );
}
